import React, { useState } from 'react';
import { FileText, Shield } from 'lucide-react';
import { Modal } from './Modal';
import { TermsOfServiceContent } from './TermsOfServiceContent';
import { PrivacyPolicyContent } from './PrivacyPolicyContent';

export const Footer: React.FC = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <footer className="mt-16 pt-8 border-t border-white/20">
      <div className="bg-white/5 backdrop-blur-sm rounded-lg p-8 shadow-lg">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-400">Lead Wealth A.I.</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Empowering businesses with cutting-edge AI solutions for growth and automation.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-400">Legal</h3>
            <div className="space-y-3">
              <button
                onClick={() => setShowTerms(true)}
                className="flex items-center text-gray-300 hover:text-yellow-400 transition-colors text-sm group"
              >
                <FileText className="w-4 h-4 mr-2 text-yellow-400 group-hover:scale-110 transition-transform" />
                Terms of Service
              </button>
              <button
                onClick={() => setShowPrivacy(true)}
                className="flex items-center text-gray-300 hover:text-yellow-400 transition-colors text-sm group"
              >
                <Shield className="w-4 h-4 mr-2 text-yellow-400 group-hover:scale-110 transition-transform" />
                Privacy Policy
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10">
          <p className="text-sm text-gray-400 text-center">
            &copy; {new Date().getFullYear()} Lead Wealth A.I. All rights reserved.
          </p>
        </div>
      </div>

      <Modal
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
        title="Terms of Service"
      >
        <TermsOfServiceContent />
      </Modal>

      <Modal
        isOpen={showPrivacy}
        onClose={() => setShowPrivacy(false)}
        title="Privacy Policy"
      >
        <PrivacyPolicyContent />
      </Modal>
    </footer>
  );
};
